const TokenService = {
    setToken: (token: string) => {
      sessionStorage.setItem("signature-token", token);
    },
    getToken: () => {
      return sessionStorage.getItem("signature-token");
    },
    clearToken: () => {
      sessionStorage.removeItem("signature-token");
    },
    clearSession: () => {
      sessionStorage.clear();
    },
  };
  
  export default TokenService;